import { useState, useCallback } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
  where,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../config/firebase.js";
import { toast } from "react-toastify";

export default function useCompanies() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getCompanies = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const snapshot = await getDocs(
        query(collection(db, "clients"), orderBy("enterprise", "asc"))
      );

      const list = snapshot.docs.map((doc) => ({
        uid: doc.id,
        ...doc.data(),
      }));

      setCompanies(list);
    } catch (err) {
      console.error("eroor", err);
      setError(err);
      toast.error("Server error");
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    companies,
    loading,
    error,
    getCompanies,
    setCompanies
  };
}
